"use strict";

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.array.map");

var _objectWithoutProperties = require("/Users/travis/Projects/poker/web/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _defineProperty = require("/Users/travis/Projects/poker/web/node_modules/@babel/runtime/helpers/defineProperty");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

var _slicedToArray = require("/Users/travis/Projects/poker/web/node_modules/@babel/runtime/helpers/slicedToArray");

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var e = require("react");

var t = e.createContext({
  nodes: {},
  register: function register() {},
  unregister: function unregister() {},
  namespace: ""
});
exports.NodeManager = function (_ref) {
  var r = _ref.children;

  var _e$useState = e.useState({}),
      _e$useState2 = _slicedToArray(_e$useState, 2),
      n = _e$useState2[0],
      s = _e$useState2[1],
      o = e.useRef(function () {
    return "".concat(Math.random().toString(32).substr(2, 8));
  }()),
      u = e.useCallback(function (e, t) {
    s(function (r) {
      return _objectSpread(_objectSpread({}, r), {}, _defineProperty({}, e, t));
    });
  }, []),
      a = e.useCallback(function (e) {
    s(function (t) {
      var r = t[e],
          n = _objectWithoutProperties(t, [e].map(_toPropertyKey));

      return n;
    });
  }, []),
      c = e.useMemo(function () {
    return {
      namespace: o.current,
      nodes: n,
      register: u,
      unregister: a
    };
  }, [n, u, a, o]);

  return e.createElement(t.Provider, {
    value: c
  }, r);
}, exports.useOrderedNodes = function () {
  var r = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (e) {
    return e.sort(function (e, t) {
      var r = e.compareDocumentPosition(t);
      if (4 & r || 16 & r) return -1;
      if (2 & r || 8 & r) return 1;
      if (1 & r || 32 & r) throw "Cannot sort the given nodes.";
      return 0;
    });
  };

  var _e$useState3 = e.useState([]),
      _e$useState4 = _slicedToArray(_e$useState3, 2),
      n = _e$useState4[0],
      s = _e$useState4[1],
      _e$useContext = e.useContext(t),
      o = _e$useContext.nodes,
      u = _e$useContext.namespace;

  return e.useLayoutEffect(function () {
    var e = r(Object.keys(o).map(function (e) {
      return o[e];
    }));
    s(e);
  }, [o, u]), n;
}, exports.useNodes = function () {
  var _e$useContext2 = e.useContext(t),
      r = _e$useContext2.nodes;

  return r;
}, exports.useRegisteredRef = function (r) {
  var n = e.useCallback(function (e) {
    e ? s(r, e) : o(r);
  }, [r]),
      _e$useContext3 = e.useContext(t),
      s = _e$useContext3.register,
      o = _e$useContext3.unregister;

  return n;
};